import { WpAssetMetaBoxData } from "@hooks/use-get/assets/types";
import { useUpdateAsset } from "@hooks/use-update/asset";

interface WpAssetMetaBoxInput extends WpAssetMetaBoxData {
    [key: string]: any;
}

export const useCreateAsset = () => {
    const { updateAsset, loading, error } = useUpdateAsset();
    const createAsset = async (assetValue: Partial<WpAssetMetaBoxInput>) =>
        await updateAsset("", {
            ...assetValue,
            status: "publish",
        } as WpAssetMetaBoxData);

    return {
        createAsset,
        loading,
        error,
    };
};
